/**
 * @module builder
 */
import type { QuoteDocument, QuoteSubstrate } from 'paintscout'

import type { UpdateableSubstrate, UpdateableItem } from '../../index'
import { getCheckboxes } from '../../util'

export function updateSubstrate(args: { quote: QuoteDocument; substrate: UpdateableSubstrate }): QuoteDocument {
  const { quote, substrate } = args

  const { key } = substrate

  const checkboxes = getCheckboxes(substrate as UpdateableItem)

  return {
    ...quote,
    substrates: {
      ...quote.substrates,
      [key]: {
        ...quote.substrates[key],
        label: substrate.label,
        client_label: substrate.clientLabel.useCustom ? substrate.clientLabel.custom : substrate.clientLabel.default,
        clientLabel: substrate.clientLabel,
        area_string: {
          ...quote.substrates[key].area_string,
          use_custom: substrate.substrateDescription.useCustom,
          custom: substrate.substrateDescription.custom,
          default: substrate.substrateDescription.default
        },
        ...checkboxes
      } as QuoteSubstrate
    }
  }
}
